import React from 'react';
import Pane from "../../../Components/Pane";
import PrimaryTitle from "../../../Components/PrimaryTitle";
import Text from "../../../Components/Text";
import {JOURNEYS} from "../../../constants";

const CongratulationsPage = (props) => {
    const {
        journey = JOURNEYS.PAYMENT
    } = props;

    return (
        <Pane>
            <PrimaryTitle>Payment Taken</PrimaryTitle>
            <Text>Payment has been taken successfully. The call agent will continue the process with you.</Text>
            <Text style={{marginBottom: '0'}}>In can take up to 10 seconds for the system to refresh on the agent's side.</Text>
        </Pane>
    );
}

export default CongratulationsPage;
